<script lang="ts">
	import { dev } from '$app/env';
	import { page } from '$app/state';
	import { pushToDataLayer } from '#lib/widget/analytics.js';
	import { onMount } from 'svelte';

	interface Props {
		gtmId?: string[];
		forceUse?: boolean;
	}

	let { gtmId = ['GTM-5RZT5C73'], forceUse = false }: Props = $props();

	function loadGtm(id: string) {
		// Prevent double loading same ID
		if (window.__gtmLoaded?.includes(id)) return;

		window.__gtmLoaded = window.__gtmLoaded || [];
		window.__gtmLoaded.push(id);

		// Create dataLayer
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'gtm.start': new Date().getTime(),
			event: 'gtm.js'
		});

		// Inject script
		const script = document.createElement('script');
		script.async = true;
		script.src = `https://www.googletagmanager.com/gtm.js?id=${id}`;
		document.head.appendChild(script);

		// Inject noscript iframe
		const iframe = document.createElement('iframe');
		iframe.src = `https://www.googletagmanager.com/ns.html?id=${id}`;
		iframe.height = '0';
		iframe.width = '0';
		iframe.style.display = 'none';
		iframe.style.visibility = 'hidden';
		document.body.prepend(iframe);
	}

	onMount(() => {
		if (!dev || forceUse) {
			gtmId.forEach((id) => loadGtm(id));
		}
	});

	let previousHref: string | null = null;
	$effect(() => {
		const currentHref = page.url.href;
		if (previousHref !== null && currentHref !== previousHref) {
			pushToDataLayer({
				event: 'page_view',
				page_title: document.title,
				page_location: currentHref,
				page_path: page.url.pathname
			});
		}
		previousHref = currentHref;
	});
</script>
